import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const getConversations = async (userId) => {
    const response = await axiosAgent.get(`/conversations/${userId}`);
    return response.data;
};

export const getGroups = async (userId) => {
    const response = await axiosAgent.get(`/groups/${userId}`);
    return response.data;
};

export const getMessages = async (chatId) => {
    const response = await axiosAgent.get(`/messages/${chatId}`);
    return response.data;
};

export const sendMessage = async (message) => {
    const response = await axiosAgent.post('/messages', message);
    return response.data;
};

export const uploadMedia = async (mediaFile) => {
    const data = new FormData();
    data.append('file', mediaFile);
    data.append('upload_preset', 'instaClone');
    data.append('cloud_name', 'aditya-foundation');
    // Note: This goes to Cloudinary (external API), not our backend
    const response = await axiosAgent.post(
        'https://api.cloudinary.com/v1_1/aditya-foundation/image/upload',
        data
    );
    return response.data;
};
